
import { CheckBeforeExecution } from '@/utils/Decorators';
import { Component, Emit, Prop, VModel, Vue } from 'vue-property-decorator';

type IClassesCSS = typeof HTMLElement.prototype.classList;

@Component({
    components: {},
})
export default class VSideForm extends Vue {
    @VModel({ type: Boolean, default: false, required: true })
    public showForm!: boolean;

    @Prop({ type: Array, default: () => [] })
    public headerClasses!: IClassesCSS;

    @Prop({ type: Array, default: () => [] })
    public bodyClasses!: IClassesCSS;

    @Prop({ type: String, default: '30rem' })
    public width!: string;

    @Prop({ type: Boolean, default: false })
    public noOverlay!: boolean;

    @Prop({ type: Function, default: () => true })
    executeHandle!: (ctx: any) => Promise<boolean> | boolean;

    get currentWidth() {
        return this.showForm ? this.width : 0;
    }

    @Emit('handle-scroll')
    handleScroll(event: any) {
        const target = event.target as HTMLElement;
        const { scrollTop, scrollHeight, clientHeight } = target;
        return { scrollHeight, scrollTop, clientHeight };
    }

    @CheckBeforeExecution((ctx) => (ctx as VSideForm).executeHandle(ctx))
    @Emit('close')
    public close() {
        this.showForm = false;
    }
}
